import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { isNullOrUndefinedOrEmpty } from '../../../../../helpers/common';
import { propShape } from '../../../../../helpers/custom-prop-types';
const ProfessionalUnitCompanyContactFeatures = (props) => {
    const { unit } = props;
    const { organization: { feature }, } = unit;
    const features = useMemo(() => (feature || '')
        .split('\n')
        .filter((v) => !isNullOrUndefinedOrEmpty(v))
        .map((row, key) => ({ key, row })), [feature]);
    if (!features.length) {
        return null;
    }
    return (_jsx("ul", Object.assign({ className: 'features_box' }, { children: features.map(({ key, row }) => (_jsx("ol", Object.assign({ className: 'feature_row' }, { children: row }), key))) })));
};
ProfessionalUnitCompanyContactFeatures.propTypes = {
    unit: propShape().isRequired,
};
export default ProfessionalUnitCompanyContactFeatures;
